import { useNavigate } from "react-router-dom";
import Spinner from "../../../Components/spinner";
import Badge from "../../../Components/Badge";
import { paymentStyle, statusStyle } from "../../../utils/statusColor";
import { formatDate } from "../../../utils/constant";
import { ViewButton } from "../../../Components/TableHelper";

const RecentOrders = ({ loading, data }) => {
    const navigator = useNavigate()
    const handleRedirect = (item) => {
        navigator(`/order-details/${item?._id}`);
    }

    const Tableheader = [
        "Order ID",
        "Customer",
        "Country",
        "Items",
        "Total (USD)",
        "Order Status",
        "Payment Status",
        "Date",
        "View",
    ];
    return (
        <div className="row ">
            <div className="col-md-12 grid-margin stretch-card">

                <div className="card">
                    <div className="card-body">
                        <h4>Recent orders</h4>
                        <div className="table-responsive">
                            <table
                             className="custom-table table table-striped"
                                id="myTable"
                                style={{ marginTop: "3px" }}
                            >
                                <thead>
                                   <tr>
                        {Tableheader.map((item, index) => (
                          <th className="font-weight-bold" key={index}>
                            {item}
                          </th>
                        ))}
                      </tr>
                                </thead>
                            <tbody>
  {loading ? (
    <tr>
      <td colSpan="9" className="text-center">
        <Spinner />
      </td>
    </tr>
  ) : data?.length > 0 ? (
    data.map((item) => (
      <tr key={item._id}>
        <td>{item.orderDisplayId}</td>
        <td>
                              <div style={{ fontWeight: "500" }}>
                                {`${item.customerId?.firstName || ""} ${item.customerId?.lastName || ""}`.trim()}
                              </div>
                              <small className="text-muted">
                                {item?.customerId?.email}
                              </small>
                            </td>
        <td>{item.shippingAddressId?.countryId?.countryName || "-"}</td>
        <td>{item.items?.length || 0}</td>
        <td>${item.total?.toFixed(2)}</td>
        <td>
          <Badge
            label={item.orderStatusId?.orderStatus || "-"}
            style={statusStyle(item.orderStatusId?.orderStatus)}
          />
        </td>
        <td>
          <Badge
            label={item.paymentStatusId?.paymentStatus || "-"}
            style={paymentStyle(item.paymentStatusId?.paymentStatus)}
          />
        </td>
        <td>{formatDate(item.createdAt)}</td>
        <td>
          <ViewButton
            item={item}
            handleRedirect={handleRedirect}
          />
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9" className="text-center">
        <h4>No data available</h4>
      </td>
    </tr>
  )}
</tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default RecentOrders